import { AuthUser } from '../../../core/interfaces/auth/phone-auth.interface';

export namespace AuthActions {
  export class SetUser {
    static readonly type = '[Auth] Set User';
    constructor(public payload: AuthUser) {}
  }

  export class ClearUser {
    static readonly type = '[Auth] Clear User';
  }

  export class SetToken {
    static readonly type = '[Auth] Set Token';
    constructor(public token: string) {}
  }
}
